import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/carousel/carousel.js';
import { findInVNode } from 'utils/vnode';
import s from 'components/bolt/hub/components/carousel/carousel.sss';

export default class Carousel extends BaseComp.default {

	render(props) {
		const base = super.render(props);
		const header = findInVNode(base, `.${s.header}`);
		if (header) {
			const decorativeLine = <div class={s.headerLine} />;
			header.children.push(decorativeLine);
		}
		return base;
	}

}
